import { Nullable } from '@/lib/types/Nullable';
import { Category } from '@/lib/types/interfaces/Category';
import { City } from '@/lib/types/interfaces/City';

export const generateSearchEmptyMessage = (currentCategory: Nullable<Category>, location: Nullable<City>, term: Nullable<string>) => {
  if (currentCategory?.name && location) return `We couldn’t find service providers for “${currentCategory.name}” in ${location.name}, ${location.state}`;
  if (currentCategory?.name) return `We couldn’t find service providers for “${currentCategory.name}”`;
  if (term && location) return `We couldn’t find service providers for “${term}” in ${location.name}, ${location.state}`;
  if (term) return `We couldn’t find service providers for “${term}”`;
  if (location) return `We couldn’t find service providers in ${location.name}, ${location.state}`;
  return 'We couldn’t find service providers';
};

export const generateServiceEmptyMessage = (currentCategory: Nullable<Category>) => {
  if (currentCategory?.name) return `We couldn’t find service providers for “${currentCategory.name}”`;
  return 'We couldn’t find service providers';
};
